import { LoaderComponent } from './../component/loader/loader.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from '../component/header/header.component';
import { ProviderHeaderComponent } from '../component/provider-header/provider-header.component';
import { RouterModule } from '@angular/router';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule
  ],
  declarations: [
    LoaderComponent,
    HeaderComponent,
    ProviderHeaderComponent
  ],
  exports: [
    LoaderComponent,
    HeaderComponent,
    ProviderHeaderComponent
  ],
  providers: []
})
export class SharedModule { }
